import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from '../subscription.model';
import { Model } from '../../app.model';
import { AutorunComponent } from '@myshared/autorun.component';
import { Router } from '@angular/router';
import { I18NextService } from 'angular-i18next';
import { SubscriptionService } from '../subscription.service';

@Component({
    selector: 'app-subscription-license-exceeded-card',
    templateUrl: './subscription-license-exceeded-card.component.html',
    standalone: false
})
export class SubscriptionLicenseExceededCardComponent extends AutorunComponent implements OnInit {
  @Input() subscription: Subscription;
  licenseStatus: boolean = false;

  constructor(
    private m: Model,
    private router: Router,
    private i18next: I18NextService,
    private subscriptionService: SubscriptionService
  ) {
    super();
  }

  ngOnInit() {
    this.licenseStatus = this.subscription.license_exceeded_subscription_active;
  }

  onToggle(v: boolean): void {
    this.subscriptionService.setLicenseExceededSubscription(this.subscription.appliance_id, v).subscribe({
      next: (r) => {
        this.licenseStatus = v;
      }
    });
  }
}
